// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2SdpP","list":"PatternAutocomplete_list__3pHvT"};